import type {
  GetProductSalesRankingRequestParams,
  GetProductSalesRankingResponse,
} from '@musinsa/apis-curator';
import { getProductSalesRanking } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import {
  type ProductSalesRankingResponseDTO,
  ProductSalesRankingResponseDTOSchema,
} from './sales-product-ranking.dto';

const parseItem = (
  item: GetProductSalesRankingResponse['data']['list'][number],
): ProductSalesRankingResponseDTO['list'][number] => ({
  imageUrl: item.imageUrl,
  brandName: item.brandName,
  goodsName: item.goodsName,
  goodsNo: item.goodsNo,
  price: item.price,
  totalQuantity: item.totalQuantity,
  totalCommission: item.totalCommission,
  linkUrl: item.linkUrl,
});

export type GetProductSalesRankingServiceRequestParams = GetProductSalesRankingRequestParams;

const transformProductSalesRankingResponse = async (
  params: GetProductSalesRankingServiceRequestParams,
): Promise<ProductSalesRankingResponseDTO> => {
  const { data, link } = await getProductSalesRanking(params);

  const page = params.page ?? 1;
  const size = params.size ?? 20;
  const total = link?.total ?? 0;

  return {
    list: data.list.map(parseItem),
    total,
    pagination: {
      currentPage: page ?? 1,
      pageSize: size ?? 10,
      hasNextPage: !!link?.next,
      nextPage: link?.next ?? null,
    },
  };
};

export const getProductSalesRankingService = withServiceErrorCapture(
  lazyPipe(
    transformProductSalesRankingResponse,
    validateServiceResponse(ProductSalesRankingResponseDTOSchema),
  ),
);
